// HTTP 拦截器配置区域
// 项目开发者可以在这里直接编写拦截器逻辑

import { HttpOptions, HttpError } from './types';

/**
 * 请求拦截器配置区域
 * 在这里编写请求发送前的处理逻辑
 */
export async function requestInterceptor(url: string, options: HttpOptions): Promise<{ url: string; options: HttpOptions }> {
  // ==================== 开发者编辑区域 ====================

  // 示例：添加认证头
  // const token = localStorage.getItem('auth_token');
  // if (token) {
  //     options.headers = {
  //         ...options.headers,
  //         'Authorization': `Bearer ${token}`
  //     };
  // }

  // 示例：添加公共参数
  // options.headers = {
  //     ...options.headers,
  //     'X-Client-Version': '1.0.0',
  //     'X-Request-ID': generateRequestId()
  // };

  // 示例：URL 预处理
  // if (!url.startsWith('http')) {
  //     url = `${API_BASE_URL}${url}`;
  // }

  // 示例：覆盖系统默认请求头
  // if (url.includes('/special-api/')) {
  //     options.headers = {
  //         ...options.headers,
  //         'Content-Type': 'application/xml', // 覆盖默认的 JSON
  //         'Accept': 'application/xml'
  //     };
  // }

  // 进行请求前的最后拦截
  // 1. 如果是不符合安全规范的，调用另外的接口

  // ==================== 编辑区域结束 ====================

  return { url, options };
}

/**
 * 响应拦截器配置区域
 * 在这里编写响应接收后的处理逻辑
 */
export async function responseInterceptor(response: Response): Promise<Response> {
  // ==================== 开发者编辑区域 ====================

  // 示例：统一响应格式处理
  // if (response.data && typeof response.data === 'object' && 'code' in response.data) {
  //     const data = response.data as any;
  //     if (data.code === 0) {
  //         response.data = data.data; // 提取实际数据
  //     } else {
  //         throw new Error(data.message || '请求失败');
  //     }
  // }

  // 示例：响应日志记录
  // console.log(`[HTTP Response] ${response.status} - ${response.url}`);

  // 示例：缓存处理
  // if (response.status === 200 && response.url?.includes('/api/cache/')) {
  //     localStorage.setItem(`cache_${response.url}`, JSON.stringify(response.data));
  // }

  // ==================== 编辑区域结束 ====================

  return response;
}

/**
 * 错误拦截器配置区域
 * 在这里编写错误处理逻辑
 */
export async function errorInterceptor(error: HttpError): Promise<HttpError> {
  // ==================== 开发者编辑区域 ====================

  // 示例：token 过期处理
  // if (error.status === 401) {
  //     try {
  //         await refreshToken();
  //         // 返回特殊标记，让系统重试请求
  //         return { ...error, action: 'RETRY' } as HttpError;
  //     } catch (refreshError) {
  //         // 刷新失败，跳转到登录页
  //         window.location.href = '/login';
  //         return error;
  //     }
  // }

  // 示例：全局错误提示
  // if (error.status >= 500) {
  //     showErrorNotification('服务器错误，请稍后重试');
  // } else if (error.status === 404) {
  //     showErrorNotification('请求的资源不存在');
  // }

  // 示例：错误日志上报
  // if (error.status >= 400) {
  //     reportError({
  //         url: error.response?.url,
  //         status: error.status,
  //         message: error.message,
  //         timestamp: Date.now()
  //     });
  // }

  // ==================== 编辑区域结束 ====================

  return error;
}


